/**
 * Trader-owned preferences (`users.prefs` JSONB, 2026-10-19). Set by the trader
 * (`PATCH /api/trader/me/prefs`) or by a manager on the member card; returned
 * on `/api/trader/me`. A preference, never a grant: absent = default.
 */
export interface TraderPrefs {
  /** Low bandwidth mode ("MrGreenMode"): the tab asks the feed gateway for
   *  each game's moneylines/spreads/totals only (no props, no OP prop markets),
   *  and the push stream for slower housekeeping topics. See
   *  `src/stores/lowBandwidth.ts`. */
  lowBandwidth?: boolean;
  /** "StreamRift mode" (2026-10-20): the new Penelope layout — the settings
   *  map, one action row on every screen, the table-first desk. Opt-in per
   *  trader; absent/false = today's layout. See `src/stores/streamriftMode.ts`. */
  streamriftMode?: boolean;
}

/** Normalises whatever the relay returned into a prefs object (never throws). */
export function parseTraderPrefs(raw: unknown): TraderPrefs {
  if (raw == null || typeof raw !== 'object' || Array.isArray(raw)) return {};
  const r = raw as Record<string, unknown>;
  const out: TraderPrefs = {};
  if (typeof r.lowBandwidth === 'boolean') out.lowBandwidth = r.lowBandwidth;
  if (typeof r.streamriftMode === 'boolean') out.streamriftMode = r.streamriftMode;
  return out;
}
